import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './gui-image.component.html',
})
export class GuiImageComponent implements OnInit {
    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project/components/gui-image/gui-image.component.ts